import { render, staticRenderFns } from "./RallyPrize.vue?vue&type=template&id=1300ef1a"
import script from "./RallyPrize.vue?vue&type=script&lang=ts"
export * from "./RallyPrize.vue?vue&type=script&lang=ts"
import style0 from "./RallyPrize.vue?vue&type=style&index=0&id=1300ef1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports